export default {
    //关于华翔
    companyProfile: {
        title: 'Company Overview',
    },
      //廉洁合规
  integrity: {
    p1: {
      title: "Integrity and compliance commitment",
      c1:
        "We firmly believe that integrity is the cornerstone of performance, enabling us to provide high-quality products and services, establish honest relations with customers and suppliers, and continue to win in the competition. Every member of NBHX has the responsibility to abide by our code of conduct:        ",
      l1: [
        "Comply with all applicable laws and regulations that guide our company's global business activities; Be honest, fair and reliable in handling all business activities and business relations of NBHX;",
        "Avoid any conflict of public and private interests;",
        "Foster an atmosphere of equal opportunities for everyone within the company;",
        "Committed to ensuring work safety and protecting the environment;",
        "Establish and maintain a corporate culture in which people recognize, respect and practice integrity. ",
      ],
      c2:
        "NBHX has formulated and issued the code of business conduct and ethics and anti fraud management system to ensure that every member should abide by professional ethics in business activities:",
      l2: [
        "Avoid improper payment;",
        "Understand and abide by laws related to international trade and international financial transactions;",
        "Prevention of money laundering;",
        "Respect for privacy;",
        "Develop the relationship with suppliers legally, fairly and effectively;",
        "Trade with all government representatives in accordance with the highest ethical standards;",
        "Compliance with competition laws;",
        "Avoid conflicts of interest;",
        "Other codes of ethics stipulated in the code of business conduct and ethics.",
      ],
    },
    p2: {
      title: "Content of report acceptance",
      c1:
        "NBHX accepts reports of anti fraud and conflict of interest from inside and outside the company, including the following types:",
      t1: "1. Fraud",
      l1: [
        "1.1 Accepting or paying bribes and kickbacks;",
        "1.2 Use the company's resources and position influence to seek personal interests;",
        "1.3 Transfer transactions that can make the company profitable under normal circumstances to other units for their own interests;",
        "1.4 Illegally use the company's assets, embezzle, embezzle, misappropriate and steal the company's assets;",
        "1.5 Carrying out business activities with other units on behalf of the company without authorization, causing the company to pay money or bear debts for false transactions;",
        "1.6 Deliberately concealing or misrepresenting transactions;",
        "1.7 Forging or altering accounting records or vouchers, and making false records, misleading statements or major omissions in financial and accounting reports and information disclosure;",
        "1.8 Tax evasion;",
        "1.9 Divulge the company's trade secrets or technical secrets;",
        "1.10 Engaging in illegal economic activities;",
        "1.11 Directors, supervisors, general managers and other senior managers neglect their duties and abuse their powers.",
      ],
      t2: "2. The following conflict of interest behaviors of executives or employees (and their close relatives)",
      l2: [
        "2.1 Directly or indirectly control the enterprises or competitive enterprises that trade with NBHX;",
        "2.2 Is the representative of the trading enterprise or has interests in the transaction;",
        "2.3 Accept commodities, cash or securities whose value exceeds the general gift value from trading enterprises or competitive enterprises as gifts, or accept loans and lavish hospitality;",
        "2.4 Providing significant management, consulting and other services (including serving as a director) to any other company without the consent of the company;",
        "2.5 Affect the transactions between trading enterprises or competitive enterprises and third parties (for example, coerce NBHX's suppliers to purchase from an enterprise owned by an individual);",
        "2.6 Compete with NBHX.",
      ],
    },
    p3: {
      title: "Reporting channels",
      c1:
        "NBHX report channel and open the report channel to the whole society, and receive the report information about anti fraud and conflict of interest from inside and outside the company.\n\n",
      l1: [
        "Report telephone：138 1803 7523",
        "Report Email：audit@nbhx.com",
        "Mailing address：Internal Audit Department of Ningbo Huaxiang Electronics Co., Ltd., Oriental Financial Plaza, 1168 Century Avenue, Pudong New Area, Shanghai",
      ],
      c2:'Tips for reporting',
      l2:[
          'Informants can choose to report in real name or anonymously. We will keep the identity information of the informant strictly confidential and will not allow any form of retaliation against the informant. Once retaliation is found, relevant personnel will be dealt with seriously.',
          'The information submitted by the informant shall be as detailed and specific as possible, and can provide substantive evidence or point to a clear direction of investigation.',
          'The informant shall be responsible for the authenticity of the reported content. Once verified, Huaxiang reserves the right to take legal measures or internal punishment against the informant for fabricating facts and deliberately slandering.'
        ]
    },
  },

    //全球布局
    中国: 'China',
    全球: 'Global',
    全球布局: "Global Network",
    中国布局: "Chinese Network",
    desclist: [[{
        num: 0,
        unit: 'Billion',
        title: 'Revenue in 2018',
        picture: require('../../assets/img/about/1.png')
    }, {
        num: 0,
        unit: 'sites',
        title: 'Manufacturing Facility',
        picture: require('../../assets/img/about/2.png')
    }, {
        num: 0,
        unit: '',
        title: 'The Number of Emplyees',
        picture: require('../../assets/img/about/3.png')
    }, {
        num: 0,
        unit: '',
        title: '<div>Regional R&D Centers</div><small>China | USA | Germany</small>',
        picture: require('../../assets/img/about/4.png')
    }], [{
        num: 0,
        unit: 'Billion',
        title: 'Revenue in 2018',
        picture: require('../../assets/img/about/1.png')
    }, {
        num: 0,
        unit: '',
        title: 'Manufacturing Facility',
        picture: require('../../assets/img/about/2.png')
    }, {
        num: 0,
        unit: '',
        title: 'The Number of Emplyees',
        picture: require('../../assets/img/about/3.png')
    }, {
        num: 0,
        unit: '',
        title: '<div>R&D Centers</div>',
        picture: require('../../assets/img/about/4.png')
    }]
    ],
    enterpriselist: [{
        title: 'Asia',
        list: ['China (over 50 manufacturing facilities & 1 regional R&D center)', 'Schlemmer Philippines Inc.', 'PT Schlemmer Automotive Indonesia', 'Vietnam Schlemmer Automotive Parts Co. Ltd.', 'Schlemmer (S.E.A.) Pte. Ltd. ']
    }, {
        title: 'Europe',
        list: ['NBHX TRIM', 'HIB TRIM Part Solutions', 'NBHX Trim Management Services', 'Northern Automotive Systems Limited', 'NBHX TRIM CZ s.r.o', 'SC Rolem SRL.RO']
    }, {
        title: 'North America',
        list: ['NBHX TRIM USA Corporation', 'Northern Engraving Corporation ', 'NBHX TRIM Mexico Sde R.L de C.V.MEX'],
    }
    ],
    markerTitles: [{
        x: '887',
        y: '397',
        title: 'Chengdu Huaxiang Automotive Roof System Co., Ltd.\nChengdu INOAC Huaxiang Automotive Parts Co., Ltd.\nChengdu Huaxiang Car Silencer Co., Ltd.'
    }, {
        x: '903',
        y: '403',
        title: 'Mianyang Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '971',
        y: '383',
        title: 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1058',
        y: '256',
        title: 'Liuzhou INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1102',
        y: '355',
        title: 'Changsha INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1150',
        y: '414',
        title: 'Wuhan INOAC Huaxiang Automotive Parts  Co., Ltd.\nWuhan Schlemmer Automotive Parts Co., Ltd.',
    }, {
        x: '1150',
        y: '231',
        title: 'Foshan Huaxiang Auto Headliner System Co.,Ltd.\nFoshan INOAC Huaxiang Automotive Parts Co., Ltd.\nFoshan Huaxiang Automotive Metal Parts Co., Ltd.'
    }, {
        x: '1163',
        y: '595',
        title: 'Tianjin Huaxiang Auto Headliner System Co.,Ltd.\nTianjin INOAC Huaxiang Automotive Parts Co., Ltd.\nTianjin Schlemmer Automotive Parts Co., Ltd.\nTianjin Huaxiang Automotive Metal Parts Co., Ltd.\nTianjin SMR Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1176',
        y: '364',
        title: 'Nanchang Huaxiang Automotive Parts Co., Ltd.\nNanchang Huaxiang Automotive Interior and Exterior Co., Ltd.'
    }, {
        x: '1176',
        y: '249',
        title: 'Dongguan Huaxiang Automotive Door System Co., Ltd.\nDongguan INOAC KENJOU Automotive Parts Co., Ltd.'
    }, {
        x: '1160',
        y: '209',
        title: 'Zhongshan Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '1217',
        y: '559',
        title: 'Yantai Schlemmer Automotive Parts Co., Ltd.\nYantai Aibeisi INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1236',
        y: '541',
        title: 'Qingdao Huaxiang Automotive Roof System Co., Ltd.\nQingdao Huaxiang Automotive Metal Parts Co., Ltd.'
    }, {
        x: '1242',
        y: '452',
        title: 'Yangzhou Huaxiang Automotive Door System Co., Ltd.'
    }, {
        x: '1258',
        y: '448',
        title: 'Wuxi INOAC Huaguang Automotive Parts Co., Ltd.'
    }, {
        x: '1242',
        y: '626',
        title: 'Shenyang Huaxiang Automotive Parts Co., Ltd.\nShenyang Aibisi INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1270',
        y: '440',
        title: 'Suzhou Schlemmer Automotive Parts Co., Ltd.'
    }, {
        x: '1262',
        y: '679',
        title: 'Gongzhuling INOAC Huaxiang Automotive Parts Co., Ltd.\nGongzhuling Huaxiang Auto Headliner System Co.,Ltd.'
    }, {
        x: '1295',
        y: '441',
        title: 'Shanghai Zhixuan Automotive Accessories Co., Ltd.\nShanghai INOAC Huaxiang Automotive Parts Co., Ltd.'
    }, {
        x: '1301',
        y: '403',
        title: 'NBHX Automotive Door System Co., Ltd.\nNingbo INOAC Huaxiang Automotive Parts Co., Ltd.\nNBHX Helbako Automotive Electronics Co., Ltd.\nNingbo Schlemmer Automotive Parts Co., Ltd.\nNBHX Trim Automotive Accessories Co., Ltd.\nNingbo SMR Automotive Parts Co., Ltd.\nNingbo Aibeisi INOAC Automotive Parts Co., Ltd.\nNBHX Automotive Accessories Co., Ltd.\nNingbo Mile Mould Manufacturing Co., Ltd.\nNBHX Natural Fiber Technology Co., Ltd.\nNingbo Lawrence Automotive Interior Co., Ltd.\nNBHX Automotive Surface Treatment Technology Co., Ltd.\nNBHX Automotive New Material Technology Co., Ltd.'
    }, {
        x: '1288',
        y: '689',
        title: 'Changchun Schlemmer Automotive Parts Co., Ltd.\nChangchun Huaxiang Car Silencer Co.,Ltd.'
    }, {
        x: '1100',
        y: '475',
        title: 'Zhengzhou INOAC Huaxiang Automotive Parts Co., Ltd.'
    }],
    markerTitle: ['Northern Automotive Systems Limited', 'NBHX TRIM GmbH\nHIB TRIM Part Solutions GmbH\nNBHX Trim Management Services GmbH', 'NBHX TRIM CZ s.r.o', 'SC Rolem SRL.RO', 'Vietnam Schlemmer Automotive Parts Co. Ltd.', 'Schlemmer (S.E.A.) Pte. Ltd. ', 'PT Schlemmer Automotive Indonesia', 'Schlemmer Philippines Inc.', 'NBHX TRIM Mexico Sde R.L de C.V.MEX', 'Northern Engraving Corporation ', 'NBHX TRIM USA Corporation', 'China (over 50 manufacturing facilities & 1 regional R&D center)'],
    enterpriseChinaList: [{
        title: 'East China',
        list: ['NBHX Automotive Door System Co., Ltd.', 'Ningbo INOAC Huaxiang Automotive Parts Co., Ltd.', 'NBHX Helbako Automotive Electronics Co., Ltd.', 'Ningbo Schlemmer Automotive Parts Co., Ltd.', 'NBHX Trim Automotive Accessories Co., Ltd.', 'Ningbo SMR Automotive Parts Co., Ltd.', 'Ningbo Aibeisi INOAC Automotive Parts Co., Ltd.', 'NBHX Automotive Accessories Co., Ltd.', 'Ningbo Mile Mould Manufacturing Co., Ltd.', 'NBHX Natural Fiber Technology Co., Ltd.', 'Ningbo Lawrence Automotive Interior Co., Ltd.', 'NBHX Automotive Surface Treatment Technology Co., Ltd.', 'NBHX Automotive New Material Technology Co., Ltd.', 'Shanghai Zhixuan Automotive Accessories Co., Ltd.', 'Shanghai INOAC Huaxiang Automotive Parts Co., Ltd.', 'Qingdao Huaxiang Automotive Roof System Co., Ltd.', 'Qingdao Huaxiang Automotive Metal Parts Co., Ltd.', 'Yangzhou Huaxiang Automotive Door System Co., Ltd.', 'Suzhou Schlemmer Automotive Parts Co., Ltd.', 'Wuxi INOAC Huaguang Automotive Parts Co., Ltd.', 'Yantai Schlemmer Automotive Parts Co., Ltd.', 'Yantai Aibeisi INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Central China',
        list: ['Wuhan INOAC Huaxiang Automotive Parts  Co., Ltd.', 'Wuhan Schlemmer Automotive Parts Co., Ltd.', 'Changsha INOAC Huaxiang Automotive Parts Co., Ltd.', 'Zhengzhou INOAC Huaxiang Automotive Parts Co., Ltd.', 'Nanchang Huaxiang Automotive Parts Co., Ltd.', 'Nanchang Huaxiang Automotive Interior and Exterior Co., Ltd.']
    }, {
        title: 'South China',
        list: ['Dongguan Huaxiang Automotive Door System Co., Ltd.', 'Dongguan INOAC KENJOU Automotive Parts Co., Ltd.', 'Foshan Huaxiang Auto Headliner System Co.,Ltd.', 'Foshan INOAC Huaxiang Automotive Parts Co., Ltd.', 'Foshan Huaxiang Automotive Metal Parts Co., Ltd.', 'Zhongshan Schlemmer Automotive Parts Co., Ltd.', 'Liuzhou INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'North China',
        list: ['Tianjin Huaxiang Auto Headliner System Co.,Ltd.', 'Tianjin INOAC Huaxiang Automotive Parts Co., Ltd.', 'Tianjin Schlemmer Automotive Parts Co., Ltd.', 'Tianjin Huaxiang Automotive Metal Parts Co., Ltd.', 'Tianjin SMR Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Northeast China',
        list: ['Changchun Schlemmer Automotive Parts Co., Ltd.', 'Changchun Huaxiang Car Silencer Co.,Ltd.', 'Gongzhuling INOAC Huaxiang Automotive Parts Co., Ltd.', 'Gongzhuling Huaxiang Auto Headliner System Co.,Ltd.', 'Shenyang Huaxiang Automotive Parts Co., Ltd.', 'Shenyang Aibisi INOAC Huaxiang Automotive Parts Co., Ltd.']
    }, {
        title: 'Southwest China',
        list: ['Chengdu Huaxiang Automotive Roof System Co., Ltd.', 'Chengdu INOAC Huaxiang Automotive Parts Co., Ltd.', 'Chengdu Huaxiang Car Silencer Co., Ltd.', 'Mianyang Schlemmer Automotive Parts Co., Ltd.', 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd.']
    }],
    //合作伙伴
    partnershipList: [{
        name: 'Jiangling Motors Group Co., Ltd.',
        desc: 'Jiangling Motors Group Co., Ltd. is one of China\'s largest vehicle export hubs and one of the main exporters of light-duty diesel commercial vehicles. The company owns six whole- vehicle manufacturing facilities. The company\'s vehicle products have a variety of models, and it has the ability to independently develop and manufacture six major assemblies.',
        logo: require('../../assets/img/about/partnership/1.jpg'),
        url: 'https://www.jmcg.com.cn/'
    }, {
        name: 'FAWER Automotive Parts Co., Ltd.',
        desc: 'FAWER Automotive Parts Co., Ltd. mainly produces auto part products such as environmental control systems, chassis systems, steering and transmission systems, safety systems, and engine accessory systems, and mainly supplies OEMS to companies like the FAW Group, SAIC Volkswagen, SAIC GM, and Dongfeng Shenlong. Its products are exported to more than ten countries including the United States, France, Italy, South Korea, Japan, and countries in the Middle East.',
        logo: require('../../assets/img/about/partnership/2.jpg'),
        url: 'http://www.fawer.com.cn/zh-cn/'
    }, {
        name: 'Changchun Fawsn Group Co., Ltd.',
        desc: 'With FAW Group as its joint stock company, Changchun Fawsn Group Co., Ltd. mainly engages in R&D, production and timely supplying of brake modules, steering modules, electronic and electrical modules, interior and exterior trim modules, and engine accessory modules. The majority parts supplied by the company are brands owned by FAW Group, and has established joint ventures with well-known companies in many industries around the world.',
        logo: require('../../assets/img/about/partnership/3.jpg'),
        url: 'http://www.fawsn.com.cn/'
    }, {
        name: 'Samvardhana Motherson Reflectec (SMR)',
        desc: 'Samvardhana Motherson Reflectec is one of the world\'s leading manufacturers of rear-view mirrors for passenger cars, and a pioneer in the development of smart camera technology for automotive applications. SMR is also a member of the world-renowned automotive industry supplier network Samvardhana Motherson Group (SMG).',
        logo: require('../../assets/img/about/partnership/4.jpg'),
        url: 'http://www.smr-automotive.com/en'
    }, {
        name: 'Schlemmer Holding GmbH',
        desc: 'Schlemmer Holding GmbH specializes in the development and production of highly specialized plastic and metal parts. Owing to its 60 years of wire harness protection experience, the company has become one of the world\'s leading suppliers of such product.',
        logo: require('../../assets/img/about/partnership/5.jpg'),
        url: 'http://www.schlemmer.com.cn/'
    }, {
        name: 'INOAC CORPORATION',
        desc: 'INOAC Corporation was founded in 1926.   Its product line covers automotive interior and exterior parts, interior products, various industrial materials, cosmetic containers and residential materials etc. made of PU, rubber and compound materials. ',
        logo: require('../../assets/img/about/partnership/6.jpg'),
        url: 'https://www.inoac.co.jp/'
    }, {
        name: 'FAURECIA',
        desc: 'FAURECIA, an auto parts company, is a subsidiary of the Peugeot Citroen Group of France. It is committed to providing high-quality innovative products, technical solutions, and services to auto manufacturers. It is a world leading company specialized in three areas: car seats, green mobile systems, and automotive interiors. ',
        logo: require('../../assets/img/about/partnership/7.jpg'),
        url: 'https://www.faurecia.cn/'
    }, {
        name: 'Ningbo Fulda Intelligent Technology Co., Ltd. ',
        desc: 'Ningbo Fulda Intelligent Technology Co., Ltd. is committed to the simultaneous design, development, and production of intelligent electronic integrated control systems, lighting systems, functional parts, and key systems. Its main clients include FAW Volkswagen, SAIC Volkswagen, SAIC-GM, Beijing Benz, and other OEMs. The company has strong research and development capabilities, and holds a number of national patents.',
        logo: require('../../assets/img/about/partnership/8.jpg'),
        url: 'http://www.fuerda-china.com/'
    }, {
        name: 'Helbako GmbH',
        desc: 'Headquartered in Germany, Helbako GmbH is a global automotive supplier. It was founded in 1977 and is mainly engaged in the R&D and production of electronic products for cars. Its products include electronic fuel pump control modules, headlight beam range adjustment systems, roof control systems, etc. Its main customers include BMW, Mercedes-Benz, Volkswagen, Audi, and Porsche.',
        logo: require('../../assets/img/about/partnership/9.jpg'),
        url: 'https://www.helbako.de/startseite/'
    }, {
        name: 'CIMC Vehicles (Group) Co., Ltd.',
        desc: 'CIMC Vehicles (Group) Co., Ltd. is a subsidiary of China International Marine Containers (Group) Co., Ltd. and is one of the largest private automobile enterprise groups in China. It is mainly engaged in the manufacture and sale of semi-trailers and special-purpose vehicles.',
        logo: require('../../assets/img/about/partnership/10.jpg'),
        url: 'http://www.cimcvehiclesgroup.com/'
    }, {
        name: 'ABC Technologies',
        desc: 'ABC Technologies is a world-famous manufacturer of automotive systems and components, and was established in Canada in 1974. The company has hundreds of patents in materials technologies, products, and processing systems and its product innovation capabilities are internationally renowned.',
        logo: require('../../assets/img/about/partnership/11.jpg'),
        url: 'http://www.abcgroupinc.com'
    }, {
        name: 'Wuxi Huaguang Auto Parts Group Co., Ltd.',
        desc: 'Founded in 1990, Wuxi Huaguang Auto Parts Group Co., Ltd. manufactures rolled and stamped products, assemblies, injection molded products, and extruded products, which are mainly supplied to FAW-Volkswagen, SAIC-Volkswagen, Shenlong, and many other automakers and OEMs.',
        logo: require('../../assets/img/about/partnership/12.jpg'),
        url: 'http://www.huaguang-group.com/'
    }],
    //客户
    navlist: ['Overseas Customers', 'JV OEMs', 'Domestic OEMs', 'New Sectors in the Industry'],
    //荣誉
    awardList: [
        [{
            poster: require('../../assets/img/about/award/2019-1.jpg'),
            year: 'Year 2019',
            title: 'Excellent Enterprise of Automotive Parts Supply Chain',
            content: 'Changchun Huaxiang Car Muffer Co.,Ltd. won the "Excellent Enterprise of Automotive Parts Supply Chain 2019" Award by China Federation of Logistics and Purchasing(CFLP)'
        }], [{
            poster: require('../../assets/img/about/award/b-1.jpg'),
            year: 'Year 2018',
            title: 'Excellent Developer & Supplier Award',
            content: 'NBHX Trim Automotive Accessories Co., Ltd. won the "2018 Excellent Developer & Supplier" Award by FAW-VW'

        }, {
            poster: require('../../assets/img/about/award/b-2.jpg'),
            year: 'Year 2018',
            title: 'National High-Tech Enterprise Award',
            content: 'Nanchang Huaxiang Automotive Parts Co., Ltd. won the "National High-Tech Enterprise " Award jointly issued by Jiangxi Provincial Taxation Bureau, Jiangxi Provincial Department of Science and Technology, and Jiangxi Provincial Department of Finance, etc.'

        }, {
            poster: require('../../assets/img/about/award/b-5.jpg'),
            year: 'Year 2018',
            title: 'Q1 Award',
            content: 'Chongqing SMR Huaxiang Automotive Parts Co., Ltd. won the "Q1 Award" by Changan Ford Automobile Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/b-3.jpg'),
            year: 'Year 2018',
            title: 'Q1 Award',
            content: 'Ningbo SMR Huaxiang Automotive Mirrors Co., Ltd. won the "Q1 Award" by Changan Ford Automobile Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/b-4.jpg'),
            year: 'Year 2018',
            title: 'JLRQ Excellent Supplier Award',
            content: 'Ningbo SMR Huaxiang Automotive Mirrors Co., Ltd. won the "JLRQ Excellent Supplier Award" by Jaguar Land Rover Automotive PLC'

        }, {
            poster: require('../../assets/img/about/award/b-6.jpg'),
            year: 'Year 2018',
            title: 'Excellent Supplier Award',
            content: 'Ningbo INOAC Huaxiang Automotive Parts Co., Ltd. won the "2018 Excellent Supplier" Award by Brilliance Auto Group'

        }, {
            poster: require('../../assets/img/about/award/b-7.jpg'),
            year: 'Year 2018',
            title: 'General Manager Excellence Award',
            content: 'Ningbo Schlemmer Automotive Parts Co., Ltd. won the "General Manager Quality Excellence" Award by CNHTC'

        }, {
            poster: require('../../assets/img/about/award/b-8.jpg'),
            year: 'Year 2018',
            title: 'Certificate of "Zhejiang Famous Brand Product"',
            content: 'NBHX Electronic Co., Ltd. is granted the "Zhejiang Famous Brand Product " Certificate by Quality and Technical Supervision Bureau of Zhejiang Province'

        }], [{
            poster: require('../../assets/img/about/award/a-1.jpg'),
            year: 'Year 2017',
            title: '20-Year Zhihe Jinshi Award',
            content: 'Changchun Huaxiang Car Silencer Co.,Ltd. won the "20-Year Zhihe Jinshi "Award by FAW Car Co., Ltd.'

        }, {
            poster: require('../../assets/img/about/award/a-2.jpg'),
            year: 'Year 2017',
            title: 'Special Contribution Award',
            content: 'Changchun Huaxiang Car Silencer Co.,Ltd. won the"Special Contribution" award by FAW Car Co., Ltd.'

        }], [{
            poster: require('../../assets/img/about/award/1.jpg'),
            year: 'Year 2016',
            title: 'Excellent Supplier Award',
            content: 'NBHX Electronic Co., Ltd. won the "2016 Excellent Supplier" Award by SAIC-VW'

        }, {
            poster: require('../../assets/img/about/award/2.jpg'),
            year: 'Year 2016',
            title: 'Quality Achievement Award',
            content: 'Changchun Huaxiang Car Muffer Co.,Ltd. won the "Quality Achievement" Award by Tianjin FAW Toyota Motor Co. Ltd'

        }, {
            poster: require('../../assets/img/about/award/3.jpg'),
            year: 'Year 2016',
            title: 'A-Level Supplier Award',
            content: 'Changchun Huaxiang Car Silencer Co.,Ltd. won the "A-Level Supplier Award" by FAW-VW'

        }]],
    合作共赢: 'Win-Win Collaboration',
    contact: {
        c1: 'Address: 6F Block A, Oriental Financial Plaza, No.1168, Century Avenue, Pudong, Shanghai, China ',
        c2: 'Post Code: 200122',
        c3: 'Telephone: +86 21 68949998',
        text: 'Contact information of subsidiaries',
        t1: 'We are committed to providing high quality products and services to our customers. To ensure the realization, we persist to work with qualified and efficient suppliers. We are always looking for new partners to maintain our high quality and market leading position. If you are interested in development together with us, please fill out the attached supplier survey and forward to <a href="mailto:supplierinfo@nbhx.com.cn">supplierinfo@nbhx.com.cn</a>.',
        t2: 'Supplier Survey'
    }
}
